import React from 'react';

export default function Sidebar({ currentPage, setCurrentPage, setIsLoggedIn }) {
  return (
    <aside className="sidebar">
      <div className="logo">TA SHOP</div>
      <nav className="nav">
        <button className={currentPage === 'dashboard' ? 'active' : ''} onClick={() => setCurrentPage('dashboard')}>
          📊 Dashboard
        </button>
        <button className={currentPage === 'users' ? 'active' : ''} onClick={() => setCurrentPage('users')}>
          👥 Users
        </button>
        <button className={currentPage === 'products' ? 'active' : ''} onClick={() => setCurrentPage('products')}>
          📦 Products
        </button>
        <button className={currentPage === 'orders' ? 'active' : ''} onClick={() => setCurrentPage('orders')}>
          📋 Orders
        </button>
      </nav>
      <button className="logout" onClick={() => setIsLoggedIn(false)}>Logout</button>
    </aside>
  );
}
